import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { Observable } from "rxjs";
import { map, take, tap } from "rxjs/operators";

import { UserService } from "../user.service";

@Injectable()
export class NoAuthGuard implements CanActivate {
  constructor(private router: Router, private userService: UserService) {}

  public canActivate(): Observable<boolean> {
    // i.e. if isAuthenticated is false, then set canActivate to true
    return this.userService.isAuthenticated.pipe(
      take(1),
      map((bool) => !bool),
      tap((res) => {
        if (!res) {
          this.router.navigate(["/"]);
        }
      })
    );
  }
}
